var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<dias-textbaustein id=\"{{ vm.param_id }}\" ng-attr-name=\"{{ vm.param_id }}\" ng-model=\"vm.parameter[vm.key].wert\" txt-gruppen=\"vm.parameter[vm.key].options.textbausteingruppen\"></dias-textbaustein>");;return buf.join("");
}